import { useEffect, useState } from 'react'

import { useGetQRAScenariosQuery } from 'app/services/api/qra/assessmentScenarios'
import CreateWISWrapper from './CreateWISWrapper'
import EditWISWrapper from './EditWISWrapper'
import {
  IQRAScenario,
  ScenarioOptions,
  WISWrapperType,
  WISViewMode
} from './types'
import ScenarioWrapper from './scenarioWrapper'

interface IWISModal {
  stateId: string
  assessmentId: string | undefined
  isModalOpen: boolean
  isRerun?: boolean
  closeModal: (pathnameOverride?: string) => void
}

const WISModalWrapper = ({
  stateId,
  assessmentId,
  isModalOpen,
  isRerun = false,
  closeModal
}: IWISModal) => {
  const [viewMode, setViewMode] = useState<WISViewMode>('run')
  const { currentData: allScenarios } = useGetQRAScenariosQuery()
  const [wisName, setWisName] = useState<string>('')

  const WISModalWrapper: Record<string, React.FC<WISWrapperType>> = {
    create: CreateWISWrapper,
    edit: EditWISWrapper
  }

  const [scenarioOptions, setScenarioOptions] = useState<ScenarioOptions>([])

  useEffect(() => {
    if (allScenarios == null) {
      return
    }

    setScenarioOptions(
      allScenarios.map((scenario: IQRAScenario) => {
        return { label: scenario.name, value: scenario.id }
      })
    )
  }, [allScenarios])

  const isCreateOrEditMode = viewMode === 'edit' || viewMode === 'create'

  if (isCreateOrEditMode) {
    return (
      <ScenarioWrapper
        setViewMode={setViewMode}
        viewMode={viewMode}
        scenarioOptions={scenarioOptions}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
      />
    )
  } else {
    const WISWrapper = WISModalWrapper[isRerun ? 'edit' : 'create']

    return (
      <WISWrapper
        assessmentId={assessmentId}
        stateId={stateId}
        setViewMode={setViewMode}
        scenarioOptions={scenarioOptions}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        wisName={wisName}
        setWisName={setWisName}
      />
    )
  }
}

export default WISModalWrapper
